import { TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StyledTableHeadingCell } from "./styled";

type Props = {
  fields: { name: string; width?: string }[];
  translationNs: string;
};

export const SimpleTableHeader = ({ fields, translationNs }: Props) => {
  const { t } = useTranslation();
  return (
    <TableRow>
      {fields.map((field, i) => (
        <StyledTableHeadingCell width={field.width || "200px"} key={i}>
          {t(`${translationNs}:${field.name}`)}
        </StyledTableHeadingCell>
      ))}
      <StyledTableHeadingCell />
    </TableRow>
  );
};
